import { PageId } from 'routing/pages'

/**
 * The pages whose tabs and widgets are saved dashboards. Their lag is worked out
 * from the data sources each time they render and never read from the saved
 * config: a stored copy goes stale whenever a source's delay changes, and some
 * delays (segments, category performance) are counted from today. Other pages
 * keep their own lag in page state.
 *
 * Kept apart from `rangeLag` so the dashboard reducer can read it without
 * importing the data source configuration.
 */
export const DERIVED_LAG_PAGES: PageId[] = [
    'dashboardPage',
    'homePage',
    'dashboardPrintPage',
]

export const derivesRangeLag = (pageName: PageId): boolean =>
    DERIVED_LAG_PAGES.includes(pageName)
